import { UpdateSectionComponent } from './../update/update.component';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from './../../../../shared/Services/PagingService';
import { FormsSectionsService } from '../../services/forms.sections.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { CreateFormSectionComponent } from '../create/create.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'form-sections-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFormSectionComponent extends BaseComponent implements OnInit {
  formMasterId: number;
  constructor(
    public route: Router,
    public service: FormsSectionsService,
    public paging: PagingService,
    private diag: NbDialogService,
    private aRoute: ActivatedRoute,
    private toaster: NbToastrService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.formMasterId = this.aRoute.snapshot.params.id;
    this.pagingModel.query.searchTerm = 'FormMasterId:' + this.formMasterId;
    this.loadEntities();
  }

  formsfields(id, sectionId) {
    this.route.navigate([`admin/dynamicForms/sections/${sectionId}/formsfields/${id}`]);
  }

  addSection() {
    this.diag
      .open(CreateFormSectionComponent, { context: { formMasterId: this.formMasterId } })
      .onClose.subscribe((res) => {
        if (res === 'true') this.ngOnInit();
      });
  }

  backToForms() {
    this.route.navigate(['admin/dynamicForms']);
  }

  update(id) {
    this.diag.open(UpdateSectionComponent, { context: { sourceId: id } }).onClose.subscribe((res) => {
      if (res === 'true') this.ngOnInit();
    });
  }

  delete(id) {
    this.service.delete(id).subscribe(
      (res) => {
        this.toaster.success(`delete section successfully`, 'success', { duration: 4000 });
        this.ngOnInit();
      },
      (errorr) => {
        this.toaster.danger('Not Allowed to delete this section before delete all fields related to it', 'Failed', {
          status: 'danger',
          duration: 4000,
        });
      }
    );
  }
}
